/* istanbul ignore file */
import type { ComponentProps } from 'react';

import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';

import { ActionBar as ActionBarSunrise } from './ActionBar';
import { ActionBar as ActionBarLegacy } from './ActionBarLegacy';

export const ActionBar = (props: ComponentProps<typeof ActionBarLegacy>) => {
	const isSunriseThemeEnabled = useIsSunriseTheme();

	if (isSunriseThemeEnabled) return <ActionBarSunrise {...props} />;

	return <ActionBarLegacy {...props} />;
};
